module.exports = __webpack_public_path__ + "static/media/expense.a31bb1ba.svg";